import { useEffect } from "react";
import { useDashContext } from "../context/DashboardContext";

// Wires a page's dirty flag into the app-wide unsaved-changes guard:
// the side nav / app bar confirm before navigating, and the browser
// warns on refresh or tab close.
export default function useUnsavedChangesGuard(dirty) {
  const { setHasUnsavedChanges } = useDashContext();

  useEffect(() => {
    setHasUnsavedChanges(dirty);
    return () => setHasUnsavedChanges(false);
  }, [dirty, setHasUnsavedChanges]);

  useEffect(() => {
    if (!dirty) return;
    const onBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [dirty]);
}
